import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import swal from "sweetalert";
import useApiServices from "../../utils/useApiServices";

import {
  AGGREGATOR_UPDATE,
  GET_ALL_AGGREGATOR,
  GET_ALL_PRIVILAGES,
  GET_ALL_PRIVILAGES_BY_ID,
} from "../../utils/constant";
import MasterMerchantForm from "./MasterMerchantForm";

const offcanvasStyle = { width: "90vw" };

const MasterMerchantEdit = ({ id, show, onHide, onSuccess }) => {
  const { apiCallFnforGet, apiCallFnforPut } = useApiServices();

  const [loading, setLoading] = useState(false);
  const [aggregatorData, setAggregatorData] = useState(null);
  const [privilegesData, setPrivilegesData] = useState([]);
  const [selectedPrivileges, setSelectedPrivileges] = useState([]);

  /* =========================
     FETCH DATA
  ========================= */
  useEffect(() => {
    if (!id || !show) return;

    const fetchData = async () => {
      try {
        const [aggRes, priRes, priByIdRes] = await Promise.all([
          apiCallFnforGet(`${GET_ALL_AGGREGATOR}/${id}`),
          apiCallFnforGet(GET_ALL_PRIVILAGES),
          apiCallFnforGet(`${GET_ALL_PRIVILAGES_BY_ID}/${id}`),
        ]);

        setAggregatorData(aggRes?.data?.[0] || null);
        setPrivilegesData(priRes?.data || []);
        setSelectedPrivileges(
          (priByIdRes?.data || []).map((p) => p.adminPrivilegeSubTypeId + "")
        );
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [id, show]);

  /* =========================
     SUBMIT
  ========================= */
  const handleUpdate = async (payload) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "Do you want to update the Master Merchant?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirm) return;

    setLoading(true);

    const res = await apiCallFnforPut(AGGREGATOR_UPDATE, {
      ...payload,
      masterMerchantId: aggregatorData?.masterMerchantId,
    });

    setLoading(false);

    if (res?.statusCode === 200) {
      swal("Success", "Aggregator Updated Successfully", "success");
      onHide();
      onSuccess?.();
    } else {
      swal("Error", res?.message || "Update failed", "error");
    }
  };

  const handleClose = () => {
    setAggregatorData(null);
    setPrivilegesData([]);
    setSelectedPrivileges([]);
    onHide();
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      style={offcanvasStyle}
    >
      <div
        className="d-flex justify-content-start align-items-center mt-3"
        style={{ marginLeft: "28px" }}
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <h5 class="offcanvas-title fs-2 text-dark fw-bold" id="offcanvasLabel">
          Edit Master Merchant
        </h5>
      </div>
      <Offcanvas.Body>
        {aggregatorData && (
          <MasterMerchantForm
            mode="edit"
            initialData={aggregatorData}
            privilegesData={privilegesData}
            selectedPrivileges={selectedPrivileges}
            setSelectedPrivileges={setSelectedPrivileges}
            onSubmit={handleUpdate}
            loading={loading}
          />
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MasterMerchantEdit;
